<template>
    <div class="sfbz">
        <div class="searchall">

                 <van-cell-group>


                     <van-field
                     class="shuru"
    v-model="name"
    name="收入名称"
    input-align='right'
    label="收入名称"
    placeholder="请输入收入名称"
 ></van-field>
                     <van-field
                     class="shuru"
    v-model="unitName"
    name="营业公司名称"
    input-align='right'
    label="营业公司名称"
    placeholder="请输入营业公司名称"
 ></van-field>












                 </van-cell-group>
            <div class="btns">
                
                <button class="searchbt" style="margin-left:20px" @click="search">搜索</button>
            </div>
            
        </div>
        <div class="wenzi">
            共计{{total}}条数据
        </div>
        <div class="sfbzcontent">
            <div class="bz">
                <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
				<div class="fyitem" v-for="(item, fyindex) in list" :key="fyindex">
                    <div class="fyxx" @click="goxq(item.id)">
                        <span>小区名称：{{ item.villageName}}</span>
                        <span>营业公司名称：{{ item.unitName}}</span>
                        <span>营业公司联系人：{{ item.linkName}}</span>
                        <span>应缴金额：{{ item.total||"暂无"}}</span>
                                               <span v-if="item.isPay=='已缴'">缴费状态：已缴</span>
                        <span v-if="item.isPay=='未缴'">缴费状态：未缴</span>
                        <span v-if="item.isPay=='已退款'">缴费状态：已退款</span>
                    </div>
                </div>
			</van-list>
            </div>
        </div>
        <div style="height:20px;width:100%"></div>
    </div>
</template>
<script>
import { ImagePreview,Dialog } from 'vant';
export default {
    data() {
        return {
            pageNum:0,
            loading: false,//列表加载的
            finished: false,//列表加载的
            refreshing: false,//列表加载的
            refreshing:false,
            ss:'',
            list:[],
            total:'',
            starttime:'',
            endtime:'',
            build:"",
            bunit:"",
            floor:"",
            name:"",
            unitName:"",
            house:"",
            buildingId:"",//楼栋号
            bunitId:"",//单元号
            floorId:'',//楼层号
            houseId:"",//门牌号
            showbuild:false,
            showbunit:false,
            showfloor:false,
            showhouse:false,
            buildarr:[],
            bunitarr:[],
            floorarr:[],
            housearr:[],
        }
    },
    mounted() {
        // this.getBuilds()
        // this.onLoad()
    },
    methods: {
        goxq(id,type){

                
                this.$router.push({ path: "/wyfw/ggsydetail", query: {id:id} });//进入物业-缴费详情页 
            

            
        },
        handleBunit(){
            if(this.buildingId==''){
                Dialog({ message: '您还没有选择楼栋！' });
                return
            }else{
                this.showbunit = true
            }
        },
        handleFloor(){
            if(this.buildingId==''||this.bunitId==''){
                Dialog({ message: '您还没有选择楼栋或单元！' });
                return
            }else{
                this.showfloor = true
            }
        },
        handleHouse(){
            if(this.buildingId==''||this.bunitId==''||this.floorId==''){
                Dialog({ message: '您还没有选择楼栋、单元或楼层！' });
                return
            }else{
                this.showhouse = true
            }
        },
        getBuilds(){
            				this.$axios.get('/api/v2/wechat/select/building',{
                    params: {
                        communityId:this.list[0].villageId,
                        key:''
                    }
                }).then(res=>{
                    this.buildarr=res
				})
        },
        getBunit(){
            				this.$axios.get('/api/v2/wechat/select/bunit',{
                    params: {
                       buildingId:this.buildingId
                    }
                }).then(res=>{
                    this.bunitarr=res
				})
        },
        getFloor(){
            				this.$axios.get('/api/v2/wechat/select/floor',{
                    params: {
                       bunitId:this.bunitId
                    }
                }).then(res=>{
                    this.floorarr=res
				})
        },
        getHouse(){
            				this.$axios.get('/api/v2/wechat/select/house',{
                    params: {
                       floorId:this.floorId
                    }
                }).then(res=>{
                    this.housearr=res
				})
        },
        onConfirmbuild(value){
            this.build=value.text
            this.buildingId=value.id
            this.getBunit()
            this.showbuild=false
        },
        onConfirmbunit(value){
            this.bunit=value.text
            this.bunitId=value.id
            this.getFloor()
            this.showbunit=false
        },
        onConfirmfloor(value){
            this.floor=value.text
            this.floorId=value.id
            this.getHouse()
            this.showfloor=false
        },
        onConfirmhouse(value){
            this.house=value.text
            this.houseId=value.id
            this.showhouse=false
        },
        chongzhi(){
            this.starttime = ''
            this.endtime = ''
            this.ss = ''
            this.list = []
            this.pageNum = 0
            this.onLoad()
        },
        search(){
            this.list = []
            this.pageNum = 0
            this.onLoad()
        },
        showimg(index){
            var that = this
            ImagePreview({
                images: that.list[index].attachs.map(item=>{
                    return item.webUrl
                }),
                closeable: true,
            });
        },
        getdata(pgn){
            this.$axios.get('/api/v1/jSbank/getGgsyList', {
                    // categoryName:yzxm,
                //    token:JSON.parse(localStorage.getItem('userInfo')).token,
                   params:{name:this.name,
                   unitName:this.unitName,
                   pageNum:pgn,
                   pageSize:12,
                   villageId:""}
                
            }).then(res => {
                // console.log(res)
                // this.total = res.total
                // this.list = res.data

                          if (this.pageNum == 0) {
            this.list = res.data;

          } else {
            if (res.data) {
              this.list = this.list.concat(res.data);
            }
          }

          this.loading = false;
          this.refreshing = false;

          if (!res.data|| res.data.length < 12) {
            this.finished = true;
          } else {
            this.pageNum++;
            this.finished = false;
          }
          this.total=res.total



                
// this.getBuilds()
            });
        },
        onLoad(){
            // setTimeout(() => {
            //     if (this.refreshing) {

            //         this.pageNum = 1;
            //         this.list = [];
            //         this.refreshing = false;
            //     }
            //     this.getdata(this.ss,this.pageNum)
            //     this.pageNum++;
            //     this.loading = false;
            //     if (this.list.length >= this.total) {
            //         this.finished = true;
            //     }
            // }, 500);
                       if (this.refreshing) {
				// 清空列表数据
				this.pageNum = 1;
				this.list = [];
				this.refreshing = false;
           }
           this.getdata(this.pageNum)
        }
    },
}
</script>
<style lang="less" scoped>
    .sfbz{
        .sfbzcontent{
            margin: 2% 5%;
        }
        .van-list{
            width: 100%;
        }
        .van-swipe-item{
            img{
            height: 100%;
            width: 100%;
            }
        }
        .searchall{
            width: 100%;
            padding: 10px;
            display: flex;
            flex-direction: column;
            input{
                outline: none;
                border: 1px solid #939393;
                border-radius: 5px;
                height: 30px;
            }
        }
        .wenzi{
            width: 90%;
            margin: 0 auto;
            color:#999;
            font-size: 13px;
        }
        .btns{
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 10px;
        }
        .searchbt{
            height: 30px;
            width: 100px;
            background: #00b5ff;
            border-radius: 10px;
            border: none;
            outline: none;
            color: #fff;
        }
        .search{
            display: flex;
            align-items: center;
            font-size: 13px;
            text-align: center;
            span{
                width: 30%;
            }
        }
        .datesearch{
            input{
                width: 34%;
            }
        }
        .bz{
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            width: 100%;
            border-radius: 10px;
            box-shadow: 0 0 10px #dadada;
            padding: 0 10px;
            box-sizing: border-box;
            .fyitem {
                margin-top: 10px;
                width: 100%;
                display: flex;
                border: 1px dashed #00b5ff;
                border-radius: 5px;
                box-sizing: border-box;
                padding: 5px 10px;
                pre{
                    margin-top: 5px;
                    margin-bottom: 0;
                    margin-left: 5px;
                    white-space: pre-wrap;
                }
                .lb {
                    width: 35%;
                    height: 100%;
                }
                .fyxx {
                    margin-left: 2%;
                    font-size: 13px;
                    width: 100%;
                    height: 100%;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    span:not(:nth-child(1)){
                        margin-top: 5px;
                    }
                }
            }
        }
    }
</style>